<template>
  <section>
    <div class="box">
      <div class="box-title">
        <h3>WebHook Personalizado Mensagens</h3>
      </div>
      <div class="box-content">
        <p>
          Configure o nosso webhook no seu painel. Basta copiar o link
          do webhook abaixo e cadastrar no painel.
        </p>
        <form>
          <div>
            <input
              class="input"
              type="text"
              v-model="urlWebhook"
              readonly="true"
            />
          </div>
          <div class="margin-top-s">
            <div class="button primary" @click="copyLink(urlWebhook)">
              Copiar webhook
            </div>
          </div>
        </form>
        <div class="margin-top-l">
          <p>
            Para garantir o funcionamento correto da integração você precisa
            cadastrar o webhook para todos seus produtos e todos os status
            possíveis.
          </p>
        </div>

        <div class="margin-top-l">
          <p>
            Exemplo de como precisa ser enviados os dados. Lembrando que sempre precisa ser uma mensagem do tipo POST com as informações em JSON na requisição.
          </p>
          <div class="flex w100 code margin-top-l" v-html="customFormat">
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "custom-mensagens",
  data() {
    return {
      baseUrlWebhook: "https://wh.unicotracker.com.br/webhook/v1/message/custom/",
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),
    urlWebhook() {
      return `${this.baseUrlWebhook}${this.account.id}/`;
    },
    customFormat() {
      return `
{
    <br>
    "event_type": "message.create",<br>
    "external_id": "",<br>
    "phone": "55419999999",<br>
    "name": "",<br>
    "sck": "",<br>
    "src": "",<br>
    "utm_campaign": "",<br>
    "utm_medium": "",<br>
    "utm_source": "",<br>
    "utm_content": "",<br>
    "utm_term": "",<br>
    "created_isoformat": "2024-09-23T13:34:37Z",<br>
}
<br>
`
    },
  },
  mounted() {},
  methods: {
    copyLink(link) {
      let copyText = link;
      navigator.clipboard.writeText(copyText);

      this.$toast.success({
        title: "Sucesso",
        message: "Link do Webhook copiado!",
      });
    },
  },
};
</script>
